import React from "react";
import { useGLTF } from "@react-three/drei";

export default function RombekWzmocnienie({ material, ...props }) {
  const { nodes, materials } = useGLTF("/models/rombek/rombek-wzmocnienie.glb");

  const mat = material ?? materials["Dark metal"];

  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes["dachowka-drugi-element"].geometry}
        material={mat}
        castShadow
        receiveShadow
        frustumCulled={false}
      />
    </group>
  );
}

useGLTF.preload("/models/rombek/rombek-wzmocnienie.glb");
